import { createSelector } from 'reselect';
import _ from 'lodash';

const getRoles = state => state.employee.role.roles;

const getUserPermissions = state => state.employee.role.assignablePermissions;

export const getManagerAvailablePermission = createSelector(
  getRoles,
  roles => {
    const role = _.find(roles, { level: 2 });
    if (role) {
      return _.groupBy(role.permissions, 'id');
    }
    return {};
  }
);

export const getUserPermissionsOf = createSelector(
  getUserPermissions,
  permissions => {
    permissions = _.sortBy(permissions, 'priority_rank');
    const permissionsOf = _.groupBy(permissions, 'access');
    return {
      app: permissionsOf.App,
      backOffice: permissionsOf['Back-office'],
    };
  }
);

export const getSubMenuOf = createSelector(
  getUserPermissions,
  permissions => {
    return _.groupBy(permissions, permission => permission.menu.toLowerCase());
  }
);
